import allowedNameRegex from 'common/constants/regex/allowedNameRegex';

export default (value = '') => !allowedNameRegex.test(value);
